import bettingEvents from '@gin-betting/betting-events';

import { BettingConfigCtx } from 'root/bettingConfigCtx';

const {
    hooks: { makeUseEventHandler },
} = bettingEvents;

export default makeUseEventHandler(BettingConfigCtx);
